module.exports = __webpack_public_path__ + "img/ntu.26e12437.png";